import React from "react";

const cards = [
  { name: "Oguzhan Cosgun", phone: "0151 123456789" },
  { name: "Kai Grall", phone: "0176 987654321" },
];

function getInitials(name) {
  return name.split(" ").map(n => n[0]).join("").toUpperCase();
}

const BusinessCards = () => (
  <section id="business-cards" className="py-5">
    <div className="container">
      <h2 className="h3 mb-4 text-center">Ihre Ansprechpartner</h2>
      <div className="row justify-content-center">
        {cards.map((card, idx) => (
          <div className="col-12 col-sm-6 col-lg-4 mb-4" key={idx}>
            <div className="modern-bizcard h-100 p-4 text-center shadow-sm">
              <div className="bizcard-avatar mx-auto mb-3">
                <span>{getInitials(card.name)}</span>
              </div>
              <h5 className="mb-2">{card.name}</h5>
              <div className="bizcard-contact mb-2">
                <a href={`tel:${card.phone.replace(/\s/g, '')}`} className="bizcard-link">
                  <i className="fas fa-phone-alt me-2 text-primary"></i>{card.phone}
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default BusinessCards;


// WEBPACK FOOTER //
// ./src/components/BusinessCards.js